<h5 class="cm-filter-title">{{ $label() }}</h5>
<div class="cm-list">
    <ng-content></ng-content>
</div>
